var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 11.6667H7.66675C7.11446 11.6667 6.66675 12.1145 6.66675 12.6667V18.889H13.3334V12.6667C13.3334 12.1145 12.8857 11.6667 12.3334 11.6667Z",
    stroke: "#666666",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.4445,
    cy: 15.5556,
    r: 1.66667,
    fill: "#F7E237"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 18.8888H3.66675C2.56218 18.8888 1.66675 17.9934 1.66675 16.8888V8.28712C1.66675 7.57677 2.04354 6.91971 2.65664 6.56095L9.05245 2.81833C9.68099 2.45053 10.4598 2.45344 11.0855 2.82592L17.3564 6.55863C17.9622 6.91924 18.3334 7.57218 18.3334 8.27721V15.5957",
    stroke: "#666666",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSpace);
export default __webpack_public_path__ + "static/media/search_space.c9e60ee09506f8a0117b3e7fd5046ea4.svg";
export { ForwardRef as ReactComponent };